import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
`;

export const ButtonGrid = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    max-width: 200px;
  }
`;
